export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'
export const FETCH_STATEMENTS = 'FETCH_STATEMENTS'
export const FETCH_MORE_STATEMENTS = 'FETCH_MORE_STATEMENTS'

export const SAVING_FORM = 'SAVING_FORM'
